import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V3, post } from "../api";

export interface BillElectricityPurchasePayload {
  pin: string;
  service_type: string;
  meter_no: string;
  amount: number;
  phone: string;
  payment_option_code: string;
  agentReference: string;
}

/**
 * Electricity purchase via the provider-agnostic bills layer (/v3/bills).
 * The response data may include a `token` for prepaid meters.
 */
function useBillElectricityPurchase(
  options?: MutationOptions<
    APIResponse<any>,
    APIError,
    BillElectricityPurchasePayload
  >
) {
  const {
    mutate: purchaseElectricity,
    isLoading: purchasingElectricity,
    isError: isPurchaseError,
    error: purchaseError,
    data: purchaseResponse,
  } = useMutation<APIResponse<any>, APIError, BillElectricityPurchasePayload>(
    (payload) =>
      post(API_URL_V3 + "/bills/electricity/purchase", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    purchaseElectricity,
    purchasingElectricity,
    isPurchaseError,
    purchaseError,
    purchaseResponse,
  };
}

export default useBillElectricityPurchase;
